import React from 'react';
import styled from 'styled-components';
import { SubscriptionHeading, UserInfo } from './ClientProfileSection';
import { ClientDetail } from '../../types/adminPortalApiSchema';

const Links = styled.ul`
  list-style-type: disc;
  margin-left: 2rem;
  columns: 2;
  column-gap: 2rem;
`;

const Link = styled.li`
  margin-bottom: 0.5rem;
`;

export function ClientLinks({ user }: { user: ClientDetail }) {
  const links: Array<{ href: string; name: string }> = [
    {
      href: `https://app.revenuecat.com/customers/${process.env.REACT_APP_REVENUECAT_PROJECT_ID}/${user.id}`,
      name: 'RevenueCat',
    },
    {
      href: `https://app.iterable.com/users/profiles/${user.email}/fields`,
      name: 'Iterable',
    },
    {
      href: `https://app.amplitude.com/analytics/thebodycoach/project/${process.env.REACT_APP_AMPLITUDE_PROJECT_ID}/search/user_id=${user.id}`,
      name: 'Amplitude',
    },
    {
      href: `https://console.firebase.google.com/project/the-body-coach/crashlytics/app/android:com.thebodycoach/search?time=last-thirty-days&q=${user.id}`,
      name: 'Crashlytics Android',
    },
    {
      href: `https://console.firebase.google.com/project/the-body-coach/crashlytics/app/ios:com.thebodycoach.bodycoach-ios/search?time=last-thirty-days&q=${user.id}`,
      name: 'Crashlytics iOS',
    },
    {
      href: `https://dashboard.stripe.com/${process.env.REACT_APP_STRIPE_ACCOUNT_ID}/search?query=${user.id}`,
      name: 'Stripe',
    },
  ];

  return (
    <>
      <SubscriptionHeading>External Links</SubscriptionHeading>
      <UserInfo>
        <Links>
          {links.map((link) => (
            <Link key={link.name}>
              <a href={link.href} target="_blank" rel="noreferrer">
                {link.name}
              </a>
            </Link>
          ))}
        </Links>
      </UserInfo>
    </>
  );
}
